import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  constructor(private router: Router) { }

  public goToLogin(): void {
    this.router.navigate(['/login']);
  }

  public goToHome(): void {
    this.router.navigate(['/home']);
  }

  public goToClients(): void {
    this.router.navigate(['/clients']);
  }

  public goToClientEdit(id: number): void {
    this.router.navigate(['/clients/edit', id]);
  }

  public goToDepartments(): void {
    this.router.navigate(['/departments']);
  }

  public goToDepartmentEdit(id: number): void {
    this.router.navigate(['/departments/edit', id]);
  }

  public goToCollaborators(): void {
    this.router.navigate(['/collaborators']);
  }

  public goToCollaboratorEdit(id: number): void {
    this.router.navigate(['/collaborators/edit', id]);
  }

  public goToKeyDrivers(): void {
    this.router.navigate(['/keydrivers']);
  }

  public goToKeyDriverEdit(id: number): void {
    this.router.navigate(['/keydrivers/edit', id]);
  }

  public goToResources(): void {
    this.router.navigate(['/resources']);
  }

  public goToResourceEdit(id: number): void {
    this.router.navigate(['/resources/edit', id]);
  }

  public goToActions(): void {
    this.router.navigate(['/actions']);
  }

  public goToActionEdit(id: string): void {
    this.router.navigate(['/actions/edit', id]);
  }

  public goToQuestions(page?: number): void {
    if (page) {
      this.router.navigate([`/questions/${page}`]);
    } else {
      this.router.navigate(['/questions']);
    }
  }

  public goToQuestionEdit(id: number, page?: number): void {
    if (page)
      this.router.navigate([`/questions/edit/${id}/${page}`]);
    else
      this.router.navigate(['/questions/edit', id]);
  }

  public goToPolls(): void {
    this.router.navigate(['/polls']);
  }

  public goToPollEdit(id: number): void {
    this.router.navigate(['/polls/edit', id]);
  }

  public goToPollDeliveries(id: string): void {
    this.router.navigate(['/polls/deliveries', id]);
  }

  public goToMissions(): void {
    this.router.navigate(['/missions']);
  }

  public goToMissionEdit(id: string): void {
    this.router.navigate(['/missions/edit', id]);
  }

  public goToPollResponse(): void {
    this.router.navigate(['/pollResponse']);
  }

  public goToComments(): void {
    this.router.navigate(['/comments']);
  }

  /*public goToValidateCode(): void {
    this.router.navigate(['/authenticate/validateCode']);
  }

  public goToHome(): void {
    this.router.navigate(['/']);
  }

  public goToImportCommercies(): void {
    this.router.navigate(['/comercies/import']);
  }*/

}
